/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelist_DateInputs */

const id_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal`)
};

const ms_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh`)
};

const da_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato`)
};

const de_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const en_us2_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const es_es2_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const es_mx2_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const fil_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa`)
};

const fr_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const it_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const hu_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dátum`)
};

const nl_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const no_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato`)
};

const pl_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const pt_br2_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const pt_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const ro_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const fi_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päiväys`)
};

const sv_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const vi_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

const tr_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih`)
};

const cs_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const bg_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const ru_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const uk_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const ar_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التاريخ`)
};

const hi_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख़`)
};

const th_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่`)
};

const ja_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

const zh_cn2_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const zh_hant1_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const ko_components_changelist_date = /** @type {(inputs: Components_Changelist_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Components_Changelist_DateInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_date = /** @type {((inputs?: Components_Changelist_DateInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_DateInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_date(inputs)
	if (locale === "ms") return ms_components_changelist_date(inputs)
	if (locale === "da") return da_components_changelist_date(inputs)
	if (locale === "de") return de_components_changelist_date(inputs)
	if (locale === "en-US") return en_us2_components_changelist_date(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_date(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_date(inputs)
	if (locale === "fil") return fil_components_changelist_date(inputs)
	if (locale === "fr") return fr_components_changelist_date(inputs)
	if (locale === "it") return it_components_changelist_date(inputs)
	if (locale === "hu") return hu_components_changelist_date(inputs)
	if (locale === "nl") return nl_components_changelist_date(inputs)
	if (locale === "no") return no_components_changelist_date(inputs)
	if (locale === "pl") return pl_components_changelist_date(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_date(inputs)
	if (locale === "pt") return pt_components_changelist_date(inputs)
	if (locale === "ro") return ro_components_changelist_date(inputs)
	if (locale === "fi") return fi_components_changelist_date(inputs)
	if (locale === "sv") return sv_components_changelist_date(inputs)
	if (locale === "vi") return vi_components_changelist_date(inputs)
	if (locale === "tr") return tr_components_changelist_date(inputs)
	if (locale === "cs") return cs_components_changelist_date(inputs)
	if (locale === "bg") return bg_components_changelist_date(inputs)
	if (locale === "ru") return ru_components_changelist_date(inputs)
	if (locale === "uk") return uk_components_changelist_date(inputs)
	if (locale === "ar") return ar_components_changelist_date(inputs)
	if (locale === "hi") return hi_components_changelist_date(inputs)
	if (locale === "th") return th_components_changelist_date(inputs)
	if (locale === "ja") return ja_components_changelist_date(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_date(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_date(inputs)
	return ko_components_changelist_date(inputs)
});
export { components_changelist_date as "components.changelist.date" }